import Api from "./api";

const normalizeNotice = (payload) => {
  const data = payload?.response ?? payload?.Response ?? payload;
  if (!data || !data.id) return null;
  return data;
};

const LoginUpdateNoticeService = {
  async getCurrent() {
    const response = await Api.get("/login-update-notice/current", {
      validateStatus: (status) => (status >= 200 && status < 300) || status === 204,
    });

    if (response.status === 204) return null;
    return normalizeNotice(response.data);
  },
};

export default LoginUpdateNoticeService;
